const size = {
  mobileS: '320px',
  mobileM: '420px',
  mobileL: '680px',
  tablet: '768px',
  laptop: '1024px',
  laptopM: '1200px',
  laptopL: '1550px',
  desktop: '2560px'
}

export default {
  mobileS: `(max-width: ${size.mobileS})`,
  mobileM: `(max-width: ${size.mobileM})`,
  mobileL: `(max-width: ${size.mobileL})`,
  tablet: `(max-width: ${size.tablet})`,
  laptop: `(max-width: ${size.laptop})`,
  laptopM: `(max-width: ${size.laptopM})`,
  laptopL: `(max-width: ${size.laptopL})`,
  desktop: `(max-width: ${size.desktop})`,
  desktopL: `(max-width: ${size.desktop})`
};